// extracted by mini-css-extract-plugin
export var actionNav = "components-home-__ActionNav-module___actionNav";
export var actionNavItems = "components-home-__ActionNav-module___actionNavItems";
export var actionNavLink = "components-home-__ActionNav-module___actionNavLink";
export var actionNavLinkIcon = "components-home-__ActionNav-module___actionNavLinkIcon";